// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fiksuweb-logo.dark[data-v-65fda8f9] path.st0 {\n  fill: #fafafa !important;\n}\n.fiksuweb-logo.dark[data-v-65fda8f9] path.st1 {\n  fill: #fd1919 !important;\n}\n.fiksuweb-logo.dark[data-v-65fda8f9] path.st2 {\n  fill: #929292 !important;\n}\n", ""]);
// Exports
module.exports = exports;
